import { useRouter } from 'next-nprogress-bar';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export function useStartFormStepper() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const totalSteps = 11;
  const currentStep = Math.max(
    Math.min(parseInt(searchParams.get('step') || '1', 10), totalSteps),
    1,
  );

  const previousStep = currentStep > 1 ? currentStep - 1 : null;
  const nextStep = currentStep < totalSteps ? currentStep + 1 : null;

  const setStep = useCallback(
    (step: number) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('step', step.toString());
      router.push(`${pathname}?${newSearchParams.toString()}`, undefined);
    },
    [pathname, router, searchParams],
  );

  return {
    currentStep,
    currentStepNumber: currentStep,
    setStep,
    previousStep,
    nextStep,
  };
}
